import React, { Fragment, useEffect, useState } from "react";

const Vocabulary = () => {
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState("");
  const [tableData, setTableData] = useState([]);

  const fetchTables = async () => {
    try {
      const response = await fetch(`/api/table`);
      const jsonData = await response.json();
      setTables(jsonData);
    } catch (err) {
      console.error("Error fetching tables:", err);
    }
  };

  // Fetch data from a specific table
  const fetchTableData = async (tableName) => {
    if (!tableName) return;
    try {
      const response = await fetch(`/api/table/${tableName}`);
      const jsonData = await response.json();
      setTableData(jsonData);
    } catch (err) {
      console.error(`Error fetching data for table ${tableName}:`, err);
    }
  };

  const handleTableSelect = (e) => {
    const tableName = e.target.value;
    setSelectedTable(tableName);
    fetchTableData(tableName);
  };

  useEffect(() => {
    fetchTables();
  }, []);

  return (
    <div>
      <h3>Lists</h3>
      <select onChange={handleTableSelect} value={selectedTable}>
        <option value="">All Tables</option>
        {tables.map((table, index) => (
          <option key={index} value={table.table_name}>
            {table.table_name}
          </option>
        ))}
      </select>
      
      <div className="listspace">
        <h4>Data for: {selectedTable}</h4>
        {tableData.length > 0 ? (
          <table>
            <thead>
              <tr>
                {Object.keys(tableData[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {Object.values(row).map((value, colIndex) => (
                    <td key={colIndex}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No data to display for this table.</p>
        )}
      </div>
    </div>
  );
};

export default Vocabulary;
